import { computed } from '@angular/core';
import { ChatStore } from './chat.store';

// Singleton instance of the store
// const store = inject(ChatStore);

/**
 * ✅ Select a chat by chatId and groupId.
 */

type ChatStoreType = InstanceType<typeof ChatStore>;

export function selectChat(chatId: string, groupId: string, store: ChatStoreType) {
  return computed(() =>
    store.chats().find(c => c.chatId === chatId && c.groupId === groupId) ?? null
  );
}

/**
 * ✅ Select messages for a given chatId and groupId.
 */
export function selectMessages(chatId: string, groupId: string, store: ChatStoreType) {
  return computed(() =>
    store.chats().find(c => c.chatId === chatId && c.groupId === groupId)?.messages ?? []
  );
}

/**
 * ✅ Select loading state for the given chatId and groupId.
 */
export function selectIsLoading(chatId: string, groupId: string, store: ChatStoreType) {
  return computed(() =>
    store.chats().find(c => c.chatId === chatId && c.groupId === groupId)?.isLoading ?? false
  );
}
